<div class="flex flex-row h-full mic-login">
  <div class="flex flex-col justify-center items-center h-full grow-1 gap-14">
    <div class="flex flex-col justify-center m-0">
      <h1 class="heading m-0">Michelin Retread Technologies</h1>
      <h1 class="heading m-0">BibTread Next</h1>
    </div>
    @if (sessionExpiredMessage) {
    <div
      class="flex flex-row items-center gap-2 p-3 w-80"
      style="background-color: #fff8e1; border: 1px solid #ffc107; border-radius: 4px; color: #856404"
    >
      <mat-icon style="color: #e65100; flex-shrink: 0">schedule</mat-icon>
      <span style="font-size: 13px">{{ sessionExpiredMessage }}</span>
    </div>
    }
    <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="dealerLoading$ | async">
      <form [formGroup]="loginForm">
        <div class="flex flex-col w-80 justify-center gap-2">
          <mat-form-field>
            <mat-label id="dealer-dropdown">Dealer</mat-label>
            <mat-select id="dealer-dropdown-input" placeholder="Select dealer name from the list" formControlName="selectedDealer">
              @for (dealer of dealers$ | async; track dealer) {
              <mat-option [value]="dealer">{{ dealer.name }}</mat-option>
              }
            </mat-select>
            @if (loginForm.get('selectedDealer').hasError('required')) {
            <mat-error>A Dealer must be selected</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label id="user-id">UserID</mat-label>
            <input
              id="user-id-input"
              matInput
              type="text"
              placeholder="UserID"
              autocomplete="username"
              formControlName="username"
              (keydown.enter)="onSubmit($event)"
            />
            @if (loginForm.get('username').hasError('required')) {
            <mat-error>UserID is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label id="password">Password</mat-label>
            <input
              id="password-input"
              matInput
              [type]="hide ? 'password' : 'text'"
              autocomplete="current-password"
              formControlName="password"
              (keydown.enter)="onSubmit($event)"
            />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (loginForm.get('password').hasError('required')) {
            <mat-error>Password is required</mat-error>
            }
          </mat-form-field>
          @if (loginFailed) {
          <mat-error id="login-error">{{ loginErrorMessage }}</mat-error>
          }
          <div class="flex flex-row justify-end">
            <button
              id="login-button"
              mat-flat-button
              color="primary"
              class="mic-login-button"
              (click)="onSubmit($event)"
              [loading]="loginProcessing"
            >
              Login
            </button>
          </div>
          @if (loginFailed) {
          <mat-error id="login-attempt-error">
            <mat-chip-set>
              @if (loginAttemptMessage) {
              <mat-chip
                disableRipple
                [color]="chipColor"
                style="
                  display: flex;
                  align-items: center;
                  padding: 14px;
                  max-width: 100%;
                  white-space: normal;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <mat-icon style="flex-shrink: 0">info</mat-icon>
                <span style="font-size: 10px; padding-left: 8px; max-width: 200px; white-space: normal; flex-grow: 1">
                  {{ loginAttemptMessage }}
                </span>
              </mat-chip>
              }
            </mat-chip-set>
          </mat-error>
          }
        </div>
      </form>
    </mic-spinner-overlay>
    <div class="flex flex-row items-center gap-4 mic-login-footer">
      <p>Powered by</p>
      <mic-logo type="group"></mic-logo>
    </div>
  </div>
  <div class="md-hidden mic-login-trapeze w-4on12"></div>
</div>
